<template>
  <div class="cost-table">
    <md-card-header>
      <span class="card-title">{{ L(titleKey) }}</span>
    </md-card-header>
    <md-card-content class="md-layout">
      <GChart
        type="PieChart"
        :data="chartData"
        :options="chartOptions"
        ref="chart"
        class="md-layout-item md-size-35"
      />
      <div class="md-layout-item md-size-65">
        <md-table
          v-model="sortedData"
          class="min-table"
          md-thin
          md-stripe
          md-fixed-header
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
            @click.native.stop="tableRowClick(item)"
          >
            <md-table-cell :md-label="L(nameKey)" style="width: 40%">
              {{ item.name }}({{ item.id }})</md-table-cell
            >
            <md-table-cell :md-label="L('cost')" md-numeric>
              {{ item.cost | formatCurrency(currency) }}
            </md-table-cell>
            <md-table-cell
              v-if="!hasCreditKind"
              :md-label="L('credit')"
              md-numeric
            >
              {{ item.credit | formatCurrency(currency) }}
            </md-table-cell>
            <md-table-cell
              v-if="hasCreditKind"
              :md-label="L('discount')"
              md-numeric
            >
              {{ item.discount | formatCurrency(currency) }}
            </md-table-cell>
            <md-table-cell
              v-if="hasCreditKind"
              :md-label="L('promotion')"
              md-numeric
            >
              {{ item.others | formatCurrency(currency) }}
            </md-table-cell>
            <md-table-cell :md-label="L('finalCost')" md-numeric>
              {{ item.finalCost | formatCurrency(currency) }}
            </md-table-cell>
          </md-table-row>
        </md-table>
        <md-table class="total-table" md-thin>
          <md-table-row slot="md-table-row">
            <md-table-cell style="width: 40%">{{
              L('totalCost')
            }}</md-table-cell>
            <md-table-cell md-numeric>{{
              totalCost.cost | formatCurrency(currency)
            }}</md-table-cell>
            <md-table-cell v-if="!hasCreditKind" md-numeric>{{
              totalCost.credit | formatCurrency(currency)
            }}</md-table-cell>
            <md-table-cell v-if="hasCreditKind" md-numeric>{{
              totalCost.discount | formatCurrency(currency)
            }}</md-table-cell>
            <md-table-cell v-if="hasCreditKind" md-numeric>{{
              totalCost.others | formatCurrency(currency)
            }}</md-table-cell>
            <md-table-cell md-numeric>{{
              totalCost.finalCost | formatCurrency(currency)
            }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </md-card-content>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  components: { GChart },

  props: {
    titleKey: String,
    nameKey: String,
    data: Array,
    currency: String,
  },

  data() {
    return {
      chartEvents: {
        select: () => {
          const selectedInfo = this.$refs.chart.chartObject.getSelection()[0]
          if (selectedInfo === undefined) return
          this.$refs.chart.chartObject.setSelection()

          this.$emit(
            'click',
            this.titleKey,
            this.sortedData[selectedInfo.row].name
          )
        },
      },
    }
  },

  computed: {
    sortedData() {
      return (this.data || []).sort((a, b) => b.cost - a.cost)
    },

    chartData() {
      return [
        [this.L('name'), this.L('finalCost')],
        ...this.sortedData
          .filter((elem) => elem.finalCost > 0)
          .map((elem) => [elem.name, elem.finalCost]),
      ]
    },

    chartOptions() {
      return {
        chartArea: {
          width: '80%',
          height: '80%',
          top: 7,
          bottom: 7,
        },
        sliceVisibilityThreshold: 0.01,
        backgroundColor: 'none',
      }
    },

    hasCreditKind() {
      return this.$config.feature.creditKind
    },

    totalCost() {
      return this.sortedData.reduce(
        (obj, elem) => {
          obj.cost += elem.cost
          obj.credit += elem.credit
          obj.discount += elem.discount
          obj.others += elem.others
          obj.finalCost += elem.finalCost
          return obj
        },
        {
          cost: 0,
          credit: 0,
          discount: 0,
          others: 0,
          finalCost: 0,
        }
      )
    },
  },

  methods: {
    tableRowClick(item) {
      this.$emit('click', this.titleKey, item.name)
    },
  },
}
</script>

<style lang="scss" scoped>
.cost-table {
  ::v-deep .md-table-cell-container,
  ::v-deep .md-table-head-label {
    padding-right: 15px !important;
    padding-left: 15px !important;
  }
}
.card-title {
  font-size: 17px;
}
.total-table {
  width: 100%;
}
</style>
